import React, { useEffect, useState } from "react";
import AppShell from "../components/layout/AppShell";
import api, { fmtDate, fmtNum } from "../lib/api";
import { PackageCheck } from "lucide-react";

export default function GoodsReceipts() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/goods-receipts").then(r=>setItems(r.data)); }, []);
    return (
        <AppShell title="Mal Kabul" subtitle="Depo">
            <div className="bg-card border border-border rounded-md">
                <div className="p-4 border-b border-border text-xs text-muted-foreground">
                    {items.length} mal kabul kaydı • Mal kabul, sipariş detayından yapılır
                </div>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>No</th><th>Tarih</th><th>PO</th><th>Tedarikçi</th>
                            <th>Depo</th><th className="text-center">Kalem</th><th className="text-right">Kabul</th><th className="text-right">Red</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(g => {
                            const accepted = g.lines?.reduce((a, l) => a + (l.accepted_qty || 0), 0) || 0;
                            const rejected = g.lines?.reduce((a, l) => a + (l.rejected_qty || 0), 0) || 0;
                            return (
                                <tr key={g.id} data-testid={`gr-row-${g.number}`}>
                                    <td className="font-mono text-xs">{g.number}</td>
                                    <td>{fmtDate(g.date)}</td>
                                    <td className="font-mono text-xs">{g.po_number}</td>
                                    <td className="font-medium">{g.supplier_name}</td>
                                    <td>{g.warehouse}</td>
                                    <td className="text-center tabular-nums">{g.lines?.length || 0}</td>
                                    <td className="text-right tabular-nums text-emerald-600">{fmtNum(accepted, 0)}</td>
                                    <td className="text-right tabular-nums text-rose-600">{fmtNum(rejected, 0)}</td>
                                </tr>
                            );
                        })}
                        {items.length === 0 && (
                            <tr><td colSpan={8} className="text-center py-16 text-muted-foreground">
                                <PackageCheck size={28} className="mx-auto mb-2 opacity-40"/>
                                Henüz mal kabul yok
                            </td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </AppShell>
    );
}
